export const img_path="/"
export const base_path="/"
export const REACT_APP_API_BASE_URL="https://dev-hrms-api.logbinary.com/api"
export const REACT_APP_NODE_API_BASE_URL="https://dev-hrms-api-v2.logbinary.com/api"
export const REACT_APP_CAREER_API_BASE_URL = "https://dev-hrms-api-v2.logbinary.com"; // NEW
export const REACT_APP_NODE_STATIC = "https://dev-hrms-api-v2.logbinary.com"
export const REACT_APP_ANALYSIS_API_BASE_URL = "http://110.225.252.131:5001";
